// Foinn.org brand mark — used everywhere the old music icon was.
export const FoinnLogo = ({ className = "h-10 w-10", rounded = "rounded-2xl" }) => (
  <img
    src="/foinn-logo.png"
    alt="Foinn.org"
    draggable={false}
    className={`${className} ${rounded} object-contain select-none`}
    data-testid="foinn-logo"
  />
);
